export const removeTransactions = () => {
  const ABTastyData = JSON.parse(window.localStorage.getItem('ABTastyData')!);
  if (ABTastyData.transactions) delete ABTastyData.transactions;
  if (ABTastyData.items) delete ABTastyData.items;
  localStorage.setItem('ABTastyData', JSON.stringify(ABTastyData));
};
